import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Row, Col } from "react-bootstrap";
import { translationConstants, globalGridActions } from "../../../constants";

const DeleteModal = (props) => {
  const { t } = useTranslation();

  // Function to split the message and bold the second part
  const renderMessage = () => {
    if (props.bold) {
      const messageParts = props.message.split(",");
      return (
        <>
          {messageParts[0]}
          <strong>{messageParts[1]}</strong>
          {messageParts[2]}
        </>
      );
    }
    return props.message;
  };

  return (
    <>
      <div className="ViewHeader">
        <p className="viewUserPara">{t(props.title)}</p>
      </div>
      <p className="horizentalLine" />

      <div className="d-flex align-items-center my-2">
        <p className="py-2 mb-3">{renderMessage()}</p>
      </div>
      <div className="d-block d-sm-flex align-items-center justify-content-center my-2">
        <Row>
          <Col className="mt-1 d-flex justify-content-center">
            <Button
              className="approve-button mx-1 "
              type="button"
              onClick={() => {
                props.removeRowData(
                  props.dataToDelete,
                  globalGridActions.DELETE
                );
              }}
            >
              {t(translationConstants.YES)}
            </Button>
          </Col>
          <Col className="mt-1 d-flex justify-content-center">
            <Button
              className="reject-button mx-1"
              type="button"
              onClick={() => {
                props.onCancel();
              }}
            >
              {t(translationConstants.NO)}
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DeleteModal;
